import { render } from "./CreateLimitStudentPassForm.vue?vue&type=template&id=7f8108d0"
import script from "./CreateLimitStudentPassForm.vue?vue&type=script&lang=js"
export * from "./CreateLimitStudentPassForm.vue?vue&type=script&lang=js"

import "./CreateLimitStudentPassForm.vue?vue&type=style&index=0&id=7f8108d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__